$.advertising = $.advertising || {};

(function ($) {
    function makeRequest(options) {
        if (typeof (options.event) == 'undefined') {
            options.event = window.event;
            options.event.returnValue = false;
        }
        else {
            options.event.preventDefault();
            options.event.stopPropagation();
        }

        options.data = options.data || [];
        options.contentType = options.contentType || 'application/application/x-www-form-urlencoded';

        var errorHandler = options.onError;
        if (!$.isFunction(options.onError) || !options.onError) {
            errorHandler = ajax.HandlePostErrors;
        }

        var completeHandler = options.onComplete;
        if (!$.isFunction(options.onComplete) || !options.onComplete) {
            completeHandler = ajax.HandlePostComplete;
        }

        $.ajax({
            type: options.type,
            url: options.url,
            contentType: options.contentType,
            data: options.data,
            beforeSend: ajax.BeforeSend,
            success: function (result) { ajax.HandlePostSuccess(result, options.onSuccess); },
            error: errorHandler,
            complete: completeHandler
        });

        return false;
    }

    $.advertising.Ajax = {
        AntiForgeryTokenName: '__RequestVerificationToken',
    };

    $.advertising.messages = {
        Generic_Error: "The operation you requested failed. Please try again."
    };

    var ajax = $.advertising.Ajax;

    ajax.HandlePostComplete = function () {
        ajax.HideLoadingIcon();
    };

    ajax.HandlePostErrors = function () {
        ajax.HideLoadingIcon();
        $.advertiser.appendErrorSummary($.advertising.messages.Generic_Error);
    };

    ajax.BeforeSend = function () {
        ajax.ShowLoadingIcon();
        $.advertiser.clearErrorSummary();
    };

    ajax.ShowLoadingIcon = function () {
        loadingPanel.show();
    };

    ajax.HideLoadingIcon = function () {
        loadingPanel.hide();
    };

    // legacy code - use $.advertiser.ajaxSuccess from osd.ui.common instead (this pretty much applies to the entire file)
    ajax.HandlePostSuccess = function (result, onSuccess) {
        var isKnownResultType = false,
            errors;

        // this behavior is NOT an exact replica of $.advertiser.ajaxSuccess; 
        // it's been enhanced to support the new generic alert functionality, 
        // but, besides that, e.g. what callbacks are called and when, 
        // it's pretty much unchanged, to maintain backward compatibility
        ajax.HideLoadingIcon();

        if (result) {
            // the result handler will ignore validation errors, if it also sees a more generic Errors property; 
            // in order to preserve backward compatibility, we need to temporarily mask the generic errors
            errors = result.Errors;
            result.Errors = null;
            isKnownResultType = $.advertiser.handleAjaxResult(result);
            result.Errors = errors;
        }

        if (!isKnownResultType) {
            // all good, if there is a custom success handler passed in, call it
            $.isFunction(onSuccess) && onSuccess(result);
        }
    };

    ajax.Post = function (options) {
        var params = '';
        var form = options.form;

        if (typeof (options.event) == 'undefined') {
            options.event = window.event;
        }

        if (typeof (options.postParams) == 'undefined') {
            options.postParams = true;
        }
        if (typeof (options.validate) == 'undefined') {
            options.validate = false;
        }

        if (typeof (options.form) === 'undefined') {
            if (typeof (options.sender) == 'undefined') {
                options.sender = $(options.event.srcElement);
            }
            options.form = options.sender.closest('form');
        }

        if (typeof (options.validate) != 'undefined' && options.validate) {
            if (!options.form.valid()) {
                return;
            }
        }

        if (options.postParams) {
            params = options.form.serialize();
        }
        else {
            params = options.form.children('[name=' + ajax.AntiForgeryTokenName + ']').serialize();
        }

        return makeRequest(options);
    };

    ajax.Get = function (options) {
        options.type = 'GET';
        return makeRequest(options);
        //return ajax.MakeRequest(options.url, options.event, 'GET', options.params, options.onSuccess, options.onError, options.onComplete);
    };

    ajax.GetAntiForgeryTokenValue = function () {
        return $('input[name="__RequestVerificationToken"]').attr("value");
    };

    ajax.GetAntiForgeryToken = function () {
        return { '__RequestVerificationToken': this.GetAntiForgeryTokenValue() };
    };

    ajax.SimplePost = function (options) {
        if (typeof (options.params) == 'undefined') {
            options.params = {};
        }

        if ($.isArray(options.params)) {
            options.params = $.makeArray(options.params);
            var hasIt = $.grep(options.params, function (n, i) {
                return n && n.name && n.name == ajax.AntiForgeryTokenName;
            });
            if (!hasIt || hasIt.length < 1) {
                options.params.push({ "name": this.AntiForgeryTokenName, "value": ajax.GetAntiForgeryTokenValue() });
            }
        } else {
            options.params[this.AntiForgeryTokenName] = ajax.GetAntiForgeryTokenValue();
        }

        $.ajax({
            type: "POST",
            url: options.url,
            data: options.params,
            success: options.onSuccess,
            error: options.onError
        });
    };

    ajax.ValidateAndPost = function (options) {
        var form = options.form;
        options.url = form.attr('action');
        options.validate = true;
        ajax.Post(options);
    };
} (jQuery));
